import { render, staticRenderFns } from "./registered-devices.vue?vue&type=template&id=50dd6352&scoped=true"
import script from "./registered-devices.vue?vue&type=script&lang=js"
export * from "./registered-devices.vue?vue&type=script&lang=js"
import style0 from "./registered-devices.vue?vue&type=style&index=0&id=50dd6352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd6352",
  null
  
)

export default component.exports